import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-新增",
  "use": "icon-新增-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-新增\"><path d=\"M512 1024a64.896 64.896 0 0 1-64.896-64.768V64.896a64.896 64.896 0 1 1 129.792 0v894.336A64.896 64.896 0 0 1 512 1024z\" fill=\"#19a5ed\" p-id=\"1734\" /><path d=\"M959.232 576.896H64.896a64.896 64.896 0 1 1 0-129.792h894.336a64.896 64.896 0 1 1 0 129.792z\" fill=\"#19a5ed\" p-id=\"1735\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol